<div class="error-container">
  <h1>{{ code }}</h1>
  <h2>{{ title }}</h2>
  <p>{{ message }}</p>

  <button routerLink="/">
    Go to Home
  </button>
</div>
